"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.10
//   protoc               v6.33.5
// source: protos/telem-metadata.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllTelemetryMetadata = exports.DimensionMetadata = exports.ChannelMetadata = exports.MetricGroupMetadata = exports.unitTypeToJSON = exports.unitTypeFromJSON = exports.UnitType = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
exports.protobufPackage = "telem_metadata";
var UnitType;
(function (UnitType) {
    UnitType[UnitType["PERCENTAGE"] = 0] = "PERCENTAGE";
    UnitType[UnitType["KW"] = 1] = "KW";
    UnitType[UnitType["KWH"] = 2] = "KWH";
    UnitType[UnitType["VOLTAGE"] = 3] = "VOLTAGE";
    UnitType[UnitType["AMPERAGE"] = 4] = "AMPERAGE";
    UnitType[UnitType["SECONDS"] = 5] = "SECONDS";
    UnitType[UnitType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(UnitType = exports.UnitType || (exports.UnitType = {}));
function unitTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "PERCENTAGE":
            return UnitType.PERCENTAGE;
        case 1:
        case "KW":
            return UnitType.KW;
        case 2:
        case "KWH":
            return UnitType.KWH;
        case 3:
        case "VOLTAGE":
            return UnitType.VOLTAGE;
        case 4:
        case "AMPERAGE":
            return UnitType.AMPERAGE;
        case 5:
        case "SECONDS":
            return UnitType.SECONDS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return UnitType.UNRECOGNIZED;
    }
}
exports.unitTypeFromJSON = unitTypeFromJSON;
function unitTypeToJSON(object) {
    switch (object) {
        case UnitType.PERCENTAGE:
            return "PERCENTAGE";
        case UnitType.KW:
            return "KW";
        case UnitType.KWH:
            return "KWH";
        case UnitType.VOLTAGE:
            return "VOLTAGE";
        case UnitType.AMPERAGE:
            return "AMPERAGE";
        case UnitType.SECONDS:
            return "SECONDS";
        case UnitType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.unitTypeToJSON = unitTypeToJSON;
function createBaseMetricGroupMetadata() {
    return { name: "", displayName: "" };
}
exports.MetricGroupMetadata = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.displayName !== "") {
            writer.uint32(18).string(message.displayName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMetricGroupMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.displayName = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            displayName: isSet(object.displayName)
                ? globalThis.String(object.displayName)
                : isSet(object.display_name)
                    ? globalThis.String(object.display_name)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.displayName !== "") {
            obj.displayName = message.displayName;
        }
        return obj;
    },
    create(base) {
        return exports.MetricGroupMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMetricGroupMetadata();
        message.name = object.name ?? "";
        message.displayName = object.displayName ?? "";
        return message;
    },
};
function createBaseChannelMetadata() {
    return { name: "", displayName: "", unitType: 0 };
}
exports.ChannelMetadata = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.displayName !== "") {
            writer.uint32(18).string(message.displayName);
        }
        if (message.unitType !== 0) {
            writer.uint32(24).int32(message.unitType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.displayName = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.unitType = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            displayName: isSet(object.displayName)
                ? globalThis.String(object.displayName)
                : isSet(object.display_name)
                    ? globalThis.String(object.display_name)
                    : "",
            unitType: isSet(object.unitType)
                ? unitTypeFromJSON(object.unitType)
                : isSet(object.unit_type)
                    ? unitTypeFromJSON(object.unit_type)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.displayName !== "") {
            obj.displayName = message.displayName;
        }
        if (message.unitType !== 0) {
            obj.unitType = unitTypeToJSON(message.unitType);
        }
        return obj;
    },
    create(base) {
        return exports.ChannelMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChannelMetadata();
        message.name = object.name ?? "";
        message.displayName = object.displayName ?? "";
        message.unitType = object.unitType ?? 0;
        return message;
    },
};
function createBaseDimensionMetadata() {
    return {
        name: "",
        displayName: "",
        entity: "",
        entityColumn: "",
        unitType: 0,
    };
}
exports.DimensionMetadata = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.displayName !== "") {
            writer.uint32(18).string(message.displayName);
        }
        if (message.entity !== "") {
            writer.uint32(26).string(message.entity);
        }
        if (message.entityColumn !== "") {
            writer.uint32(34).string(message.entityColumn);
        }
        if (message.unitType !== 0) {
            writer.uint32(40).int32(message.unitType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDimensionMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.displayName = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.entity = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.entityColumn = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.unitType = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            displayName: isSet(object.displayName)
                ? globalThis.String(object.displayName)
                : isSet(object.display_name)
                    ? globalThis.String(object.display_name)
                    : "",
            entity: isSet(object.entity) ? globalThis.String(object.entity) : "",
            entityColumn: isSet(object.entityColumn)
                ? globalThis.String(object.entityColumn)
                : isSet(object.entity_column)
                    ? globalThis.String(object.entity_column)
                    : "",
            unitType: isSet(object.unitType)
                ? unitTypeFromJSON(object.unitType)
                : isSet(object.unit_type)
                    ? unitTypeFromJSON(object.unit_type)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.displayName !== "") {
            obj.displayName = message.displayName;
        }
        if (message.entity !== "") {
            obj.entity = message.entity;
        }
        if (message.entityColumn !== "") {
            obj.entityColumn = message.entityColumn;
        }
        if (message.unitType !== 0) {
            obj.unitType = unitTypeToJSON(message.unitType);
        }
        return obj;
    },
    create(base) {
        return exports.DimensionMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDimensionMetadata();
        message.name = object.name ?? "";
        message.displayName = object.displayName ?? "";
        message.entity = object.entity ?? "";
        message.entityColumn = object.entityColumn ?? "";
        message.unitType = object.unitType ?? 0;
        return message;
    },
};
function createBaseAllTelemetryMetadata() {
    return { version: "", dimensions: [], channels: [], metricGroups: [] };
}
exports.AllTelemetryMetadata = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.version !== "") {
            writer.uint32(10).string(message.version);
        }
        for (const v of message.dimensions) {
            exports.DimensionMetadata.encode(v, writer.uint32(18).fork()).join();
        }
        for (const v of message.channels) {
            exports.ChannelMetadata.encode(v, writer.uint32(26).fork()).join();
        }
        for (const v of message.metricGroups) {
            exports.MetricGroupMetadata.encode(v, writer.uint32(34).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAllTelemetryMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.version = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.dimensions.push(exports.DimensionMetadata.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.channels.push(exports.ChannelMetadata.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.metricGroups.push(exports.MetricGroupMetadata.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            version: isSet(object.version) ? globalThis.String(object.version) : "",
            dimensions: globalThis.Array.isArray(object?.dimensions)
                ? object.dimensions.map((e) => exports.DimensionMetadata.fromJSON(e))
                : [],
            channels: globalThis.Array.isArray(object?.channels)
                ? object.channels.map((e) => exports.ChannelMetadata.fromJSON(e))
                : [],
            metricGroups: globalThis.Array.isArray(object?.metricGroups)
                ? object.metricGroups.map((e) => exports.MetricGroupMetadata.fromJSON(e))
                : globalThis.Array.isArray(object?.metric_groups)
                    ? object.metric_groups.map((e) => exports.MetricGroupMetadata.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.version !== "") {
            obj.version = message.version;
        }
        if (message.dimensions?.length) {
            obj.dimensions = message.dimensions.map((e) => exports.DimensionMetadata.toJSON(e));
        }
        if (message.channels?.length) {
            obj.channels = message.channels.map((e) => exports.ChannelMetadata.toJSON(e));
        }
        if (message.metricGroups?.length) {
            obj.metricGroups = message.metricGroups.map((e) => exports.MetricGroupMetadata.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.AllTelemetryMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAllTelemetryMetadata();
        message.version = object.version ?? "";
        message.dimensions =
            object.dimensions?.map((e) => exports.DimensionMetadata.fromPartial(e)) || [];
        message.channels =
            object.channels?.map((e) => exports.ChannelMetadata.fromPartial(e)) || [];
        message.metricGroups =
            object.metricGroups?.map((e) => exports.MetricGroupMetadata.fromPartial(e)) || [];
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
